import { IBrand } from '@/models/brands.model';
import { BrandsFormFields } from './types';
import { getFileUrlByType } from './getFileByType';

export const normalizeInitialValues = (data: IBrand) => {
  return {
    [BrandsFormFields.IMAGE_TITLE]: data?.imageTitle ?? '',
    [BrandsFormFields.LOGO]: getFileUrlByType(data, 'image'),
    [BrandsFormFields.BANNER]: getFileUrlByType(data, 'banner'),
    [BrandsFormFields.BANNER_TITLE]: data?.bannerTitle ?? '',
    [BrandsFormFields.TITLE]: data?.title ?? '',
    [BrandsFormFields.DESCRIPTION]: data?.description ?? '',
    [BrandsFormFields.SEO]: data?.seo ?? '',
  };
};
